import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Header from "../../components/Header";
import Section from "../../components/Section";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSave,
    faRotate,
    faCircleArrowLeft,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";

const ParametersForm = ({ handleLogout }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [key, setKey] = useState("");
    const [value, setValue] = useState("");
    const [type, setType] = useState("");
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [errorsMessage, setErrorMessage] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [notificationBlock, setNotificationBlock] = useState(false);
    const [messageBlock, setMessageBlock] = useState(false);

    useEffect(() => {
        if (id) {
            const fetchParameter = async () => {
                try {
                    const response = await apiClient.get(`/admin/parameters/${id}`);
                    setKey(response.data.key);
                    setValue(response.data.value);
                    setType(response.data.type);
                } catch (error) {
                    console.error("Error al cargar el Parámetro", error);
                    setErrorMessage("Oops!. Ocurrio un error al cargar el Parámetro");
                }
            };
            fetchParameter();
        }
    }, [id]);

    const validateFields = () => {
        let validationErrors = {};
        const onlyLetters = /^[a-zA-Z]+$/;
        if (!key) {
            validationErrors.key = "El Campo es Obligatorio";
        } else if (!onlyLetters.test(key)) {
            validationErrors.key = "Solo se permiten letras";
        }
        if (!value) validationErrors.value = "El Campo es Obligatorio";
        if (!type) validationErrors.type = "El Campo es Obligatorio";
        return validationErrors;
    };

    const handleCloseBlock = () => {
        setNotificationBlock(false);
    };
    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            let response;
            if (id) {
                const payloadUpdate = {
                    value,
                    type
                };
                response = await apiClient.patch(
                    `/admin/parameters/${id}`,
                    payloadUpdate
                );
                if (response.status === 200) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setIsLoginVisible(false);
                    setErrors({});
                    setTimeout(() => {
                        setIsSuccessVisible(false);
                    }, 4000);
                    navigate("/ParametersList");
                }
            } else {
                const payload = {
                    key,
                    value,
                    type
                };
                response = await apiClient.post("/admin/parameters", payload);
                if (response.status === 201) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setErrors({});
                    setTimeout(() => {
                        setIsSuccessVisible(false);
                    }, 4000);
                    navigate("/ParametersList");
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            } else if (error.response?.data?.message.startsWith("PARAMETER_ALREADY_EXIST")) {
                setMessageBlock("El Parámetro ya existe.");
                setNotificationBlock(true);
            }
            else {
                setErrorMessage("Oops!. Ocurrio un error al crear el Parámetro");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
        }
    };

    const toggleSwitch = () => {
        setValue((prev) => (prev === "true" ? "false" : "true"));
    };

    /*const handleDateChange = (date) => {
        const formattedDate = format(date, "yyyy-MM-dd HH:mm:ss");
        setValue(formattedDate);
      };*/
    const handleDateChange = (date) => {
        if (date instanceof Date && !isNaN(date)) {
            const formattedDate = format(date, "yyyy-MM-dd HH:mm:ss");
            setValue(formattedDate);
        } else {
            setValue(""); // O null, según cómo estés manejando estados vacíos
        }
    };
    const isValidDate = (date) => date instanceof Date && !isNaN(date);

    useEffect(() => {
        if (type === "date") {
            setValue("");
        } else if (type === "boolean") {
            setValue("false");
        } else {
            setValue("");
        }
    }, [type]);

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Parámetros" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/ParametersList");
                        }}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información del Parámetro</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.key ? "red" : "revert-layer" }}>
                            Código
                        </label>
                        <input
                            type="text"
                            placeholder="Código"
                            value={key}
                            onChange={(e) => setKey(e.target.value)}
                            readOnly={!!id}
                        />
                        {errors.key && <p className="error-message">{errors.key}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.type ? "red" : "revert-layer" }}>
                            Tipo
                        </label>
                        <select
                            value={type}
                            onChange={(e) => setType(e.target.value)}>
                            <option value="">Seleccione un módulo</option>
                            <option value="string">string</option>
                            <option value="integer">integer</option>
                            <option value="json">json</option>
                            <option value="float">float</option>
                            <option value="boolean">boolean</option>
                            <option value="date">date</option>
                        </select>
                        {/*<input
                            type="text"
                            placeholder="Tipo"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                        />*/}
                        {errors.type && <p className="error-message">{errors.type}</p>}
                    </div>
                    {type === "string" && (
                        <div className="basic-info-form-group">
                            <label style={{ color: errors.value ? "red" : "revert-layer" }}>Valor</label>
                            <input
                                type="text"
                                placeholder="Valor (string)"
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                            />
                            {errors.value && <p className="error-message">{errors.value}</p>}
                        </div>
                    )}
                    {type === "integer" && (
                        <div className="basic-info-form-group">
                            <label style={{ color: errors.value ? "red" : "revert-layer" }}>Valor</label>
                            <input
                                type="text"
                                placeholder="Valor (interger)"
                                value={value}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^\d{0,3}$/.test(val)) {
                                        const numericValue = Number(val);
                                        if (numericValue <= 999) {
                                            setValue(val);
                                        } else if (val === "") {
                                            setValue("");
                                        }
                                    }
                                }}
                            />
                            {errors.value && <p className="error-message">{errors.value}</p>}
                        </div>
                    )}
                    {type === "json" && (
                        <div className="basic-info-form-group">
                            <label style={{ color: errors.value ? "red" : "revert-layer" }}>Valor</label>
                            <textarea
                                placeholder="Valor (json)"
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                                rows={6}
                            />
                            {errors.value && <p className="error-message">{errors.value}</p>}
                        </div>
                    )}
                    {type === "float" && (
                        <div className="basic-info-form-group">
                            <label style={{ color: errors.value ? "red" : "revert-layer" }}>Valor</label>
                            <input
                                type="text"
                                placeholder="Valor (float)"
                                value={value}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^\d{0,3}(\.\d{0,4})?$/.test(val)) {
                                        const numericValue = parseFloat(val);
                                        if (val === "" || numericValue <= 999.9999) {
                                            setValue(val);
                                        }
                                    }
                                }}
                            />
                            {errors.value && <p className="error-message">{errors.value}</p>}
                        </div>
                    )}
                    {type === "boolean" && (
                        <div className="basic-info-form-group">
                            <label>Valor</label>
                            <div className="slider-container-contract" onClick={toggleSwitch}>
                                <div
                                    className={`slider-option-contract ${value === "true"
                                        ? "active-contract"
                                        : "inactive-contract"
                                        }`}
                                >
                                    True
                                </div>
                                <div
                                    className={`slider-option-contract ${value === "false"
                                        ? "active-contract"
                                        : "inactive-contract"
                                        }`}
                                >
                                    False
                                </div>
                            </div>
                            {errors.value && <p className="error-message">{errors.value}</p>}
                        </div>
                    )}
                    {type === "date" && (
                        <div className="basic-info-form-group">
                            <label>Valor</label>
                            <div className="basic-info-date-picker">
                                <DatePicker
                                    //selected={value ? new Date(value) : null}
                                    selected={isValidDate(new Date(value)) ? new Date(value) : null}
                                    onChange={handleDateChange}
                                    showTimeSelect
                                    locale={es}
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    placeholderText="Seleccione una Fecha"
                                    className="custom-date-picker"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                            </div>
                            {errors.value && <p className="error-message">{errors.value}</p>}
                        </div>
                    )}
                </div>
                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/ParametersList");
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button
                        className="basic-custom-button"
                        onClick={handleSave}
                    >
                        <FontAwesomeIcon
                            icon={id ? faRotate : faSave}
                            className="basic-shortcut-icon"
                        />
                        {id ? "Actualizar" : "Guardar"}
                    </button>
                </div>
            </div>
            <SuccessNotification
                message={
                    id
                        ? "El Parámetro se ha Actualizado Correctamente."
                        : "EL Parámetro se ha Creado Correctamente."
                }
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message={errorsMessage}
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuelve a iniciar sesión"
                isVisible={isLoginVisible}
                onClose={() => setIsLoginVisible(false)}
                onLogout={handleLogout}
            />
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={`No se puede Crear el Parámetro debido a : ${messageBlock}`}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={true}
                    pageNavigate={"/ParametersList"}
                    whatsApp={false} 
                />
            )}

        </div>
    );
};

export default ParametersForm;
